<template>
  <div>
    <h3>Download Sample</h3>
    <button @click="download">샘플 파일 다운로드</button>
  </div>
</template>

<script>
//import axios from 'axios'
import * as FileUtil from '@/utils/FileUtil'

export default {
  name: 'DownloadSample',
  methods:{
    download() {
      FileUtil.FileDownload('http://localhost:8080/test/fileDownload', 'sample.png');
    }
  }
}
</script>